function Documents() {
  return (
    <>
      <h1>
        Um SMS com um link foi enviado para o celular dos representantes e eles
        precisarão:
      </h1>
      <ul>
        <li>Tirar uma foto do RG ou CNH</li>
        <li>Tirar uma foto do comprovante de residência</li>
        <li>Também será solicitado que você tire uma foto sua (selfie)</li>
      </ul>
    </>
  );
}

export default Documents;
